import { useDispatch, useSelector, connect } from 'react-redux';
import SliderUI from 'react-slick';

export const BOTTOMSLIDESETTINGS = {
  swipeToSlide: false,
  swipe: false,
  dots: true,
  arrows: true,
  slidesToShow: 1,
  responsive: [
    {
      breakpoint: 1224,
      settings: {
        slidesToShow: 2,
        swipeToSlide: true,
        swipe: true,
        arrows: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        swipeToSlide: true,
        swipe: true,
        arrows: false,
      },
    },
  ],
};

export const UPPERSLIDESETTINGS = {
  swipeToSlide: false,
  swipe: false,
  dots: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 1224,
      settings: {
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        swipeToSlide: true,
        swipe: true,
        centerMode: true,
        infinite: true,
      },
    },
  ],
};
